<template>
    <div
        class="wait"
        :class="{ 'stretch-size-wrapper': stretchSizeValue }"
        :style="{
            width: computedWidth,
            paddingBottom: stretchSizeValue ? `${stretchSizeValue}%` : '',
        }"
    >
        <div
            class="lds-dual-ring"
            :class="{ 'stretch-size': stretchSizeValue }"
        ></div>
    </div>
</template>

<script>
export default {
    name: 'Wait',
    props: {
        stretchSizeValue: {
            default: null,
            type: Number,
        },
        naturalWidth: {
            default: false,
            type: Boolean,
        },
    },
    computed: {
        computedWidth: function () {
            const defaultWidth = this.$props.naturalWidth ? '' : '5rem';
            return this.$props.stretchSizeValue
                ? `${this.$props.stretchSizeValue}%`
                : defaultWidth;
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../styles/rem';
@import '../styles/mrem';
/*activate checkbox regExp in finder of phpStorm*/
/*find      {: ([0-9]*)px}*/
/*replace   {: rem($1);}*/

@keyframes lds-dual-ring {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

.wait {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}
.stretch-size-wrapper {
    overflow: hidden;
    position: relative;
    width: 10%;
    padding-bottom: 10%; // пропорции блока определяются здесь
    display: flex;
    justify-content: center; // элемент центрируется
}

.lds-dual-ring {
    display: inline-block;
    width: 5rem;
    height: 5rem;
    box-sizing: border-box;
}
.lds-dual-ring:after {
    content: ' ';
    display: block;
    width: 4.3rem;
    height: 4.3rem;
    border-radius: 50%;
    border: 0.3rem solid;
    border-color: #dbe7fb transparent #d1deff transparent;
    animation: lds-dual-ring 1.2s linear infinite;
    box-sizing: border-box;
}

.stretch-size {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
.stretch-size:after {
    width: 100%;
    height: 100%;
}

@import '../styles/variables';
@media (max-width: $vm) {
    .lds-dual-ring {
        display: inline-block;
        width: 30rem;
        height: 30rem;
    }
    .lds-dual-ring:after {
        content: ' ';
        display: block;
        width: 10rem;
        height: 10rem;
        border-radius: 50%;
        border: 1.5rem solid;
        border-color: #dbe7fb transparent #d1deff transparent;
        animation: lds-dual-ring 1.2s linear infinite;
    }

    .stretch-size {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
    .stretch-size:after {
        width: 100%;
        height: 100%;
    }
}
</style>
